// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NR","innerWrapper":"OR"};